module.exports = __webpack_public_path__ + "static/media/screenshot-10.1cb20bd5.png";